import { apiSlice } from './apiSlice';

export interface DrishtiAspect {
  planets: string;
  signs: string;
  aspectsOfSign: string;
  signAspected: string;
  houseAscpectedForLagna: string;
  anyPlanetOrSignAspected: string | null;
  houseAscpectedForRashi: string;
}

export interface DrishtiResponse {
  dhristiAspects: {
    aspects: DrishtiAspect[];
  };
}

export const drishtiApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDrishtiAspects: builder.mutation<DrishtiResponse, string | null>({
      query: (userId) => ({
        url: '/astrology/dhristi-aspects',
        method: 'POST',
        params: { userId },
      }),
    }),
  }),
});

export const { useGetDrishtiAspectsMutation } = drishtiApi;
